
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/components",
      function () {
        return require("private-next-pages/docs/components/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/components"])
      });
    }
  